/** Applications inbox — `/review-applications` only (no child segment). */
export function isReviewApplicationsListRoute(url: string): boolean {
  const path = url.split('?')[0].replace(/\/$/, '') || '/';
  return path === '/review-applications';
}

/** View / review workspace under applications (corporate, individual, KYC deep links). */
export function isReviewApplicationsDetailRoute(url: string): boolean {
  const path = url.split('?')[0];
  return /\/review-applications\/(?:individual\/)?(view|edit)(?:\/|$)/.test(path);
}
